const channelDivisionMap: any = {
  twitch: ['twitch_keyword', 'twitch_live'],
  navercafe: ['cafe'],
  youtube: ['youtube_keyword', 'youtube_live'],
  funcom: ['funcom forum'],
};

export const addStudioChannel = (channelList: Array<string>) => {
  const result: Array<string> = [];
  try {
    channelList.forEach((item) => {
      result.push(item);
      // 获取分裂值
      const divisionValue = channelDivisionMap[item];
      // 分裂值存在就添加
      if (divisionValue) {
        result.push(...divisionValue);
      }
    });
  } catch (error) {}

  return result;
};